import { makeRequest } from 'utils/requestLogger';

export default (participationID, payload) =>
  makeRequest(
    'post',
    `/api/participations/${participationID}/give_impression`,
    payload
  );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/givePoint.js